import React, { useState, useEffect, useCallback, useRef } from "react"
import { Controller, FieldValues } from "react-hook-form"
import { FileUpload } from "../../upload"
import { Translates } from "@/services/repository/i18n"
import { CurrentSession } from "@/services/repository/session"
import { Services } from "@/services/services"

import "./gallery.css"
import { FieldProps, withFieldWrap } from "../FormBase"
import { GalleryProvider, SimpleGallery } from "../gallery/gallery"
import { Stream } from "@/services/common/stream"
import { UploadStatus } from "../gallery/osfiles"

export interface Image {
  url: string
}

export interface GalleryProps<T extends FieldValues> extends FieldProps<T> {
  rules?: any
  session?: CurrentSession
}

const API_BASE = "/api/public/tmp/gallery"

export const galleryInput = <T extends FieldValues>({
  fieldName,
  formName,
  form,
  translates,
  services,
  session,
  readOnly,
  rules
}: GalleryProps<T>) => {
  const [galleryId, setGalleryId] = useState<string>()
  const statusStreamRef = useRef<Stream<UploadStatus>>(new Stream<UploadStatus>())

  if (!translates) {
    return <div className="spinner"></div>
  }

  return (
    <Controller
      name={fieldName as any}
      control={form.control}
      // defaultValue={defaultValue}
      rules={{
        ...rules,
        validate: () => {
          if (statusStreamRef.current.value()?.started) {
            return translates.for("form.fields.upload.upload_in_progress")
          }
          return true
        },
      }}
      render={({ field, fieldState }) => {
        return <GalleryProvider insertUrl={`${API_BASE}/new`} updateUrl={`${API_BASE}/{id}/upload`} fetchUrl={`${API_BASE}/{id}/list`} removeUrl={`${API_BASE}/{id}/remove/{fid}`} token={session?.token} translates={translates} galleryId={galleryId} statusStream={statusStreamRef.current}
          onChange={(id: string) => {
            setGalleryId(id)
            field.onChange(id)
          }}>
          <SimpleGallery />
        </GalleryProvider>
      }}
    />
  )
}

export const galleryField = <T extends FieldValues>() => withFieldWrap<T>(galleryInput<T>)